import { useQuery } from 'react-query';
import { WDAC_MANAGED_INSTALLER_GENERAL_QUERY_KEY } from '../../constants/query';
import useSubscribeStorage from '../../hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import ManagedInstallerService from '../../services/managed-installer.service';

const useManagedInstallersGeneral = ({ managedInstallerId }) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  return useQuery([WDAC_MANAGED_INSTALLER_GENERAL_QUERY_KEY, managedInstallerId], () =>
    ManagedInstallerService.getManagedInstallersDetails({ managedInstallerId, customerEnvId }),
  );
};

export default useManagedInstallersGeneral;
